export const WORDS = [
  'kanye',
  'donda',
  'swift',
  'pablo',
  'jesus',
  'paris',
  'roses',
  'leone',
  'barry',
  'power',
  'blame',
  'sight',
  'yeezy',
  'guilt',
  'bound',
  'hands',
  'waves',
  'saint',
  'north',
  'yikes',
  'selah',
  'water',
  'jonah',
  'junya',
  'pusha',
  'carti',
  'mercy',
  'trump',
  'skete',
  'fivio',
  'light',
  'julia',
  'amber',
  'chike',
  'tidal'
]